module.exports = __webpack_public_path__ + "static/path_of_wild_magic-90afd28aed9e098b5e6fc6def7102e80.png";